import React, {Component, useState, useRef} from 'react'
import {
    Box,
    Grid,
    GridItem,
    Button,
    Card,
    CardHeader,
    CardBody,
    HStack,
    VStack,
    Image,
    Editable,
    EditablePreview,
    EditableInput,
    Heading,
    AlertDialog,
    AlertDialogOverlay,
    AlertDialogContent,
    AlertDialogHeader,
    AlertDialogBody,
    AlertDialogFooter,

  } from '@chakra-ui/react';
  import { useOutletContext } from "react-router-dom"
  import { AddIcon, DeleteIcon } from '@chakra-ui/icons';

import Navigation from '../Navigation/Navigation';



function BooksIndex () {

  const {
    state,
    onRouteChange,
    onLogOut,
    onFormTextChangeBookTitle,
    onCreateBook,
    onViewBook,
    onDeleteBook,
    onSaveBookTitle,
    isAuthenticated
  } = useOutletContext()
      return (
        <>
          <Grid templateColumns="repeat(48, 1fr)" bg="#F5F3F0" >
          <GridItem
            as="main"
            colSpan="48"
            bg="#F5F3F0"

            >
            <Navigation
            bg = "#F5F3F0"
            state = {state}
            onRouteChange = {onRouteChange}
            onLogOut = {onLogOut}
            isAuthenticated={isAuthenticated}
            />
            <Box minH = "93vh" display="flex"  justifyContent={'center'}>
              <Grid templateColumns="repeat(4, 1fr)"  p ="10px" alignItems="center"  >
              <Books
                books = {state.books}
                onCreateBook = {onCreateBook}
                onDeleteBook = {onDeleteBook}
                onViewBook = {onViewBook}
                onFormTextChangeBookTitle = {onFormTextChangeBookTitle}
                onSaveBookTitle = {onSaveBookTitle}
              />
              </Grid>

            </Box>
          </GridItem>
          </Grid>
        </>
      )
    }

class Books extends Component {
  render() {
    let books = this.props.books
    return (
      <>
        {books['exists'] === true
          ?
          books['items'].map(book => (
              <Book
               id = {book.id}
               title = {book.title}
               onViewBook = {this.props.onViewBook}
               onDeleteBook = {this.props.onDeleteBook}
               onFormTextChangeBookTitle = {this.props.onFormTextChangeBookTitle}
               onSaveBookTitle = {this.props.onSaveBookTitle}
               />
            )
          )
          :
            null
        }
        <CreateBook
        onCreateBook = {this.props.onCreateBook}
        />
      </>
    )
  }
}

class Book extends Component {
  render() {
    return (
      <GridItem gridColumn="span 1" p="10px" w='300px'>
        <Card
          display="flex"
          flexDirection="column"
          boxShadow="0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)"
          p="6"
          rounded="xl"
          h='420px'
          bg="white"
          border="1px solid"
          borderColor="#E4E4E7"
          transition="all 0.25s ease"
          _hover={{
            transform: 'translateY(-4px)',
            boxShadow: '0 8px 24px rgba(0,0,0,0.1), 0 2px 4px rgba(0,0,0,0.04)',
            borderColor: '#A1A1AA',
          }}
        >
          <CardHeader h="12rem" overflow="hidden">
            <HStack spacing={2} align="start" w="100%">
              <Box overflow="hidden" flex="1">
                <EditableTitle
                  id={this.props.id}
                  title={this.props.title}
                  onFormTextChangeBookTitle={this.props.onFormTextChangeBookTitle}
                  onSaveBookTitle={this.props.onSaveBookTitle}
                />
              </Box>
              <DeleteBookIcon
                display="flex"
                justifyContent={'right'}
                id={this.props.id}
                onDeleteBook={this.props.onDeleteBook}
              />
            </HStack>
          </CardHeader>
          <CardBody
            flex="1"
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            p={4}
          >
            <Box
              position="relative"
              mb={6}
              transition="all 0.3s ease"
              _hover={{
                transform: 'scale(1.05)'
              }}
            >
              <Image
                src="book-icon.jpg"
                alt="Book"
                boxSize="160px"
                objectFit="contain"
                opacity="0.8"
              />
            </Box>
            <CustomButton
              text="Open"
              onClick={() => this.props.onViewBook(this.props.id)}
              w="140px"
            />
          </CardBody>
        </Card>
      </GridItem>
    )
  }
}


class EditableTitle extends Component {
  render() {
    return (
      <Editable
        defaultValue={this.props.title}
        onSubmit={(newTitle) => {
          if (newTitle !== this.props.title) {
            this.props.onSaveBookTitle(this.props.id)
          }
        }}
      >
        <Heading size="lg">
          <EditablePreview
            noOfLines={3}
            color="#1A1A1A"
            fontWeight="600"
            lineHeight="1.4"
            _hover={{
              color: '#1A1A1A'
            }}
          />
        </Heading>
        <EditableInput
          fontSize="2xl"
          onChange={(event) => {
            this.props.onFormTextChangeBookTitle('books', this.props.id, 'title', event.target.value)
          }}
          color="#1A1A1A"
          fontWeight="600"
          lineHeight="1.4"
        />
      </Editable>
    )
  }
}

const DeleteBookIcon = ({ onDeleteBook, id }) => {
  const [isOpen, setIsOpen] = useState(false);
  const cancelRef = useRef();

  const openDialog = () => setIsOpen(true);
  const closeDialog = () => setIsOpen(false);

  const handleDelete = (id) => {
    onDeleteBook(id);
    closeDialog();
  };

  return (
    <>
      <DeleteIcon
          cursor='pointer'
          color = '#E05252'
          _hover={{ color: '#C94545' }}
          onClick = {openDialog}/>

      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={closeDialog}
      >
        <AlertDialogOverlay bg="blackAlpha.400" backdropFilter="blur(4px)">
          <AlertDialogContent borderRadius="xl">
            <AlertDialogHeader fontSize="lg" fontWeight="600">
              Delete Book
            </AlertDialogHeader>

            <AlertDialogBody color="#52525B">
              Are you sure you want to delete this book? This action cannot be undone.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={closeDialog} borderRadius="lg">
                Cancel
              </Button>
              <Button bg="#E05252" color="white" _hover={{ bg: '#C94545' }} borderRadius="lg" onClick={() => {handleDelete(id)}} ml={3}>
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};



class CreateBook extends Component {
  render() {
    return (
      <GridItem gridColumn="span 1" p="10px" w='300px'>
        <Card
          display="flex"
          flexDirection="column"
          boxShadow="0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)"
          p="6"
          rounded="xl"
          h='420px'
          bg="white"
          border="1px solid"
          borderColor="#E4E4E7"
          transition="all 0.25s ease"
          _hover={{
            transform: 'translateY(-4px)',
            boxShadow: '0 8px 24px rgba(0,0,0,0.1), 0 2px 4px rgba(0,0,0,0.04)',
            borderColor: '#E05252',
            cursor: 'pointer'
          }}
          onClick={this.props.onCreateBook}
        >
          <CardBody
            flex="1"
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            p={4}
          >
            <VStack spacing={6}>
              <Heading
                fontWeight="600"
                fontSize="2xl"
                color="#1A1A1A"
                mb={2}
              >
                New Story
              </Heading>
              <Box
                p={4}
                borderRadius="full"
                bg="#FEF2F2"
                transition="all 0.3s ease"
                _hover={{
                  bg: '#FECACA'
                }}
              >
                <AddIcon
                  boxSize={8}
                  color="#E05252"
                />
              </Box>
            </VStack>
          </CardBody>
        </Card>
      </GridItem>
    )
  }
}

class CustomButton extends Component {
  render() {
    return (
      <Button
        px={6}
        w = {this.props.w}
        fontSize={'md'}
        bg={'#E05252'}
        color={'white'}
        fontWeight="600"
        borderRadius="lg"
        boxShadow="none"
        _hover={{
            bg: '#C94545',
            transform: 'translateY(-1px)',
        }}
        _focus={{
            bg: '#C94545',
        }}
        transition="all 0.2s"
        onClick = {this.props.onClick}
      >{this.props.text}
      </Button>
    )
  }
}





export default BooksIndex
